import { Box, Typography } from "@mui/material";
import Navbar from "../UI/Navbar";

function PageNotFound() {
  return (
    <Box>
      <Navbar />
      <Typography variant="h1" sx={{ textAlign: "center", mt: "20rem" }}>
        Page not found ⛔
      </Typography>
    </Box>
  );
}

export default PageNotFound;
